export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string) => EMAIL_REGEX.test(email);

export const validateEmailList = (value: string) => {
	const emails = value
		.split(",")
		.map((email) => email.trim())
		.filter((value) => value !== "");

	let isValid = true;

	const duplicateEmails = emails.filter(
		(item, index) => emails.indexOf(item) !== index
	);

	if (duplicateEmails.length > 0) {
		return "No duplicate emails allowed";
	}

	emails.forEach((email) => {
		if (!EMAIL_REGEX.test(email)) {
			isValid = false;
		}
	});

	if (!isValid) {
		return "Please enter email(s) in the correct format";
	}

	return true;
};
